module.exports = __webpack_public_path__ + "static/media/boolean-icon.3ed12319.svg";